import { Link } from 'react-router-dom';
import { AlertTriangle, ChevronRight } from 'lucide-react';

// Delhi 2028: ICE two-wheeler ban starts April 1, 2028
const BAN_DATE = new Date(Date.UTC(2028, 3, 1)); // April 1, 2028

function daysUntilBan(): number {
  const now = Date.now();
  const diff = BAN_DATE.getTime() - now;
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}

export function DelhiICEBanCountdown() {
  const days = daysUntilBan();

  if (days <= 0) return null;

  return (
    <div className="rounded-2xl border border-border-primary bg-bg-secondary overflow-hidden">
      <div className="flex items-center gap-3 px-4 py-3 bg-gradient-to-r from-amber-500/10 to-transparent">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-amber-500/15 flex-shrink-0">
          <AlertTriangle className="h-4 w-4 text-amber-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-text-secondary">Delhi ICE 2W Ban</p>
          <div className="flex items-baseline gap-1.5">
            <span className="text-lg font-bold text-amber-400 tabular-nums font-mono">{days}</span>
            <span className="text-[11px] text-text-tertiary">days remaining</span>
          </div>
        </div>
      </div>

      <Link
        to="/guides/delhi-ev-policy-2026-2030"
        className="flex items-center justify-center gap-1 border-t border-border-primary py-2.5 text-xs font-medium text-primary-500 hover:text-primary-400 transition-colors"
      >
        Switch to EV guide
        <ChevronRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  );
}
